module.exports = __webpack_public_path__ + "img/26_13.9ae9d4a5.png";